/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdTextareaProps } from './type';

export const textareaDefaultProps: TdTextareaProps = {
  allowInputOverMax: false,
  autofocus: false,
  autosize: false,
  disabled: false,
  placeholder: undefined,
  readonly: false,
  readOnly: false,
  status: 'default',
};
